import React from "react"
import Heading from "../../common/Heading"

import "./hero.css"


const Hero = () => {
  return (
    <>
      <section className='hero'>
        <div className='container'>
      
         <Heading title='Aspire Protection Services PVT.LTD.' subtitle='Your Safety, Our Priority' /> 
        

         
        </div>
      </section>
    </>
  )
}

export default Hero
